import { getFileType, getFileExtension } from 'utils/filesUtils';

/**
 * V2 file type resolver — wraps the existing getFileType utility and adds
 * support for ppt/pptx (previously fell through to 'folder') and separates
 * csv out of the generic 'xls' bucket so it gets its own table viewer.
 *
 * @param {string} fileName - display_name or file_name of the file
 * @returns {string} file type key used by ViewerRouter
 */
export function getFileTypeV2(fileName) {
  const ext = getFileExtension(fileName)?.toLowerCase();
  if (!ext) return 'folder';
  if (ext === 'ppt' || ext === 'pptx') return 'ppt';
  if (ext === 'csv') return 'csv';
  if (ext === 'zip') return 'zip';
  return getFileType(ext);
}

/**
 * Returns the raw file extension from a filename (lowercase).
 * Re-exported here so ViewerRouter and others don't need a second import path.
 */
export { getFileExtension };
